.base {
  display: inline-grid;
  place-items: center;
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  color: var(--text-secondary);
  transition:
    background var(--duration-fast) var(--ease-out),
    color var(--duration-fast) var(--ease-out),
    border-color var(--duration-fast) var(--ease-out);
}

.base:hover:not(:disabled) {
  background: var(--bg-hover);
  color: var(--text-primary);
}

.base:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.sm {
  width: 28px;
  height: 28px;
}

.md {
  width: 34px;
  height: 34px;
}

.bordered {
  border-color: var(--border-default);
  background: var(--bg-surface-raised);
}

.active {
  background: var(--accent-subtle);
  border-color: var(--accent-border);
  color: var(--accent);
}
